export const AdminApiResources = {
  signIn: 'wizard/auth/token',
  signOut: 'wizard/auth/revoke',
  refreshAdminToken: 'wizard/auth/refresh_access_token',
  resetMFA: 'wizard/auth/mfa_reset',
  mfaResetEmail: 'wizard/auth/mfa_reset_email',
  appSecret: 'wizard/auth/app_secret',
  appVerifyAndSave: 'wizard/auth/app_verify_and_save',
  smsSend: 'wizard/auth/sms_send',
  smsVerifyAndSave: 'wizard/auth/sms_verify_and_save',
  appAuth: 'wizard/auth/mfa_app_authentication',
  smsAuth: 'wizard/auth/mfa_sms_authentication',
  securityToken: 'wizard/security/token',
  securityMFA: 'wizard/security_mfa/index',
  securityApp: 'wizard/security_mfa/app_verify_and_save',
  securitySMSSend: 'wizard/security_mfa/sms_send',
  securitySMS: 'wizard/security_mfa/sms_verify_and_save',
  user: 'wizard/user',
  setPassword: 'wizard/user/set_password',
  admins: 'wizard/admins',
  setNewPassword: 'wizard/admins/set_new_password',
  sendResetPassword: 'wizard/admins/send_reset_password',
  permissions: 'wizard/admins/permissions',
  adminResetPassword: 'wizard/admins/send_reset_password_instructions',
  adminDeactivate: 'wizard/admins/deactivate',
  adminActivate: 'wizard/admins/activate',
  adminUpdate: 'wizard/admins/change_role',
  personnel: 'wizard/managers',
  accounts: 'wizard/accounts',
  accountDetails: 'wizard/accounts/details',
  sendInvitation: 'wizard/accounts/send_invitation',
  sendPasswordUpdate: 'wizard/accounts/send_password_update',
  impersonate: 'wizard/accounts/impersonate',
  hotels: 'wizard/hotels',
  hotelList: 'wizard/hotels/list',
  hotelDetails: 'wizard/hotels/details',
  customPos: 'wizard/hotels/custom_pos',
  paymentSystemGMO: 'wizard/hotels/gmo_payment_system',
  paymentSystemJTB: 'wizard/hotels/jtb_payment_system',
  paymentSystemStripe: 'wizard/hotels/stripe_payment_system',
  activatePoA: 'wizard/hotels/activate_pay_on_arrival',
  publishHotel: 'wizard/hotels/publish',
  unpublishHotel: 'wizard/hotels/unpublish',
  startHotelAri: 'wizard/hotels/start_ari',
  stopHotelAri: 'wizard/hotels/stop_ari',
  transactions: 'wizard/transactions',
  transactionsCSV: 'wizard/transactions/download_csv',
  tllSync: 'wizard/tll_sync',
  hotelInquiry: 'wizard/tll_sync/hotel_inquiry',
};
export default AdminApiResources;
